import React from "react";
import { connect } from "react-redux";
import EmailBlacklist from "../components/EmailBlacklist";
import selectEmailBlacklistContainer from "../selectors/userManagement";
import {
  getEmails,
} from "../actions/userManagement";

const EmailBlacklistContainer = (props) => <EmailBlacklist {...props} />;

const mapStateToProps = (state) => ({
  ...selectEmailBlacklistContainer(state)(state),
});

const mapDispatchToProps = (dispatch) => ({
  doFetchGetEmails: () => {
    dispatch(getEmails());
  },
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailBlacklistContainer);
